import React from 'react';
import { useTranslations } from 'next-intl';
import { DialogHeader as UIDialogHeader, DialogTitle } from '@/shared/ui/dialog';
import btnIcons from '@/shared/assets/sprites/btns.sprite.svg';
interface PhoneDialogHeaderProps {
  onClose: () => void;
}
export const PhoneDialogHeader: React.FC<PhoneDialogHeaderProps> = ({
  onClose
}) => {
  const t = useTranslations();
  return <UIDialogHeader data-sentry-element="UIDialogHeader" data-sentry-component="PhoneDialogHeader" data-sentry-source-file="PhoneDialogHeader.tsx">
      <DialogTitle className="text-lg font-bold" data-sentry-element="DialogTitle" data-sentry-source-file="PhoneDialogHeader.tsx">
        <button className="ml-auto" onClick={onClose} aria-label={t('shared.aria.close')}>
          <svg className="size-8 stroke-white" data-sentry-element="svg" data-sentry-source-file="PhoneDialogHeader.tsx">
            <use xlinkHref={`${btnIcons}#close`} data-sentry-element="use" data-sentry-source-file="PhoneDialogHeader.tsx"></use>
          </svg>
        </button>
      </DialogTitle>
    </UIDialogHeader>;
};